<div [class]="getTheme()">
  @if (!roouterPath) {
    <form>
      <div fxLayout="row">
        <div fxFlex="20" fxHide.xs="true" fxHide="false" fxHide.sm="true"  fxHide.md="true">
          <div style="width: 350px;"></div>
          <app-fixed-sidebar></app-fixed-sidebar>
        </div>
        <div class="main-container small-layout" fxFlex="80" fxFlex.xs="100" fxFlex.sm="100">
          <div class="lead-text centerText">
            <p [innerHtml]="getText() | translate | safe: 'html'"> </p>
          </div>
          <div fxLayout="column">
            <div fxFlex="80" class="content-card" fxFlex="80" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100">
              <h3>{{'menu.calibrate.ask' | translate }}</h3>
            </div>
            <div fxFlex="80" class="content-card"  fxFlex="80" fxFlex.xs="100" fxFlex.sm="100">
              <div fxLayout="row" class="block-highlights">
                <mat-card class="card" (click)="navigateToThermalOptions('protocols')" appMaterialElevation>
                  <mat-card-content class="pointerHand">
                    <div class="action-floating new-badge" (click)="newProtocol()">
                      <mat-icon>add_circle</mat-icon>
                      <span>{{ 'button.new' | translate }}</span>
                    </div>
                    <div class="action-floating info-badge" fxHide.lt-md
                      matTooltip="{{ 'menu.protocol.info' | translate }}">
                      <mat-icon color="accent">info</mat-icon>
                    </div>
                    <img class="icon" src="{{ getThemeIconPath() }}protocols.svg"
                      alt="{{ 'menu.manage' | translate }} {{ 'menu.protocol' | translate }}">
                    <span class="title accent-color">{{ 'menu.protocol' | translate }}</span>
                  </mat-card-content>
                </mat-card>
                <mat-card class="card" (click)="navigateToThermalOptions('executions')"
                  appMaterialElevation>
                  <mat-card-content class="pointerHand">
                    <div class="action-floating new-badge" (click)="newExecutions()">
                      <mat-icon>add_circle</mat-icon>
                      <span>{{ 'button.new' | translate }}</span>
                    </div>
                    <div class="action-floating info-badge" fxHide.lt-md
                      matTooltip="{{ 'menu.execution.info' | translate }}">
                      <mat-icon color="accent">info</mat-icon>
                    </div>
                    <img class="icon" src="{{ getThemeIconPath() }}executions.svg"
                      alt="{{ 'menu.manage' | translate }} {{ 'menu.execution' | translate }}">
                    <span class="title accent-color">{{ 'menu.execution' | translate }}</span>
                  </mat-card-content>
                </mat-card>
                @if (showCharacterization()) {
                  <mat-card class="card" (click)="navigateToThermalOptions('isothermalCharacterizations')"
                    appMaterialElevation>
                    <mat-card-content class="pointerHand">
                      <div class="action-floating new-badge" (click)="newIsothermalCharacterization()">
                        <mat-icon>add_circle</mat-icon>
                        <span>{{ 'button.new' | translate }}</span>
                      </div>
                      <div class="action-floating info-badge" fxHide.lt-md
                        matTooltip="{{ 'menu.isothermal-characterization.info' | translate }}">
                        <mat-icon color="accent">info</mat-icon>
                      </div>
                      <img class="icon" src="{{ getThemeIconPath() }}isothermalCharacterization.svg"
                        alt="{{ 'menu.manage' | translate }} {{ 'menu.isothermal-characterization' | translate }}">
                      <span class="title accent-color">{{ 'menu.isothermal-characterization' | translate
                      }}</span>
                    </mat-card-content>
                  </mat-card>
                }
              </div>
              <div fxLayout="row" class="block-highlights" style="margin: 0; justify-content: center;">
                <div fxFlex="100">
                  <mat-card class="card card-sub" (click)="navigateToThermalOptions('internalEquipments')"
                    appMaterialElevation>
                    <mat-card-content class="pointerHand">
                      <div class="action-floating new-badge" (click)="newInternalEquipment()">
                        <mat-icon>add_circle</mat-icon>
                        <span>{{ 'button.new' | translate }}</span>
                      </div>
                      <div class="action-floating info-badge" fxHide.lt-md
                        matTooltip="{{ 'menu.my-equipments.info' | translate }}">
                        <mat-icon color="accent">info</mat-icon>
                      </div>
                      <img class="icon" src="{{ getThemeIconPath() }}internalEquipments.svg"
                        alt="{{ 'menu.manage' | translate }} {{ 'menu.my-equipments' | translate }}">
                      <span class="title accent-color">{{ 'menu.my-equipments' | translate }}</span>
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  }

  @if (roouterPath) {
    <router-outlet></router-outlet>
  }
</div>